module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/feature2@2x.2054632.jpg";